import { createContext } from "react";

/**
 * Provides the stack entry and layer info for a modal rendered inside ModalContainer.
 * When present, useModal() returns this entry's data so each stacked modal shows its own state.
 */
export const ModalStackContext = createContext(null);
